// extracted by mini-css-extract-plugin
export default {"stat-box":"StatsGrid_stat-box__SAsk8","progress-bar":"StatsGrid_progress-bar__kQFH2","progress-fill":"StatsGrid_progress-fill__7RjoY"};